/* cr-chuppi.js — Chuppi in the corner: four answers, a way to write to her,
 * and he can be picked up and put somewhere else.
 *
 * WHAT IT IS NOT: this is not an AI agent and does not improvise. Every answer
 * below is a fixed sentence that was already checked. That is deliberate —
 * our shipping rule is conditional (free only for subscribers, D-345), and a
 * bot that says "shipping is free" to someone who has not subscribed would be
 * making a promise we did not make.
 *
 * THE MESSAGE goes through Shopify's own /contact endpoint, which emails the
 * store address. No third party, no monthly fee, nothing to maintain. The
 * fetch keeps the visitor on the page; if it fails for any reason the form
 * falls back to an ordinary submit, which always works.
 *
 * DRAGGING is the visitor's, not the shop's. Natalie asked for it in those
 * words: a floating thing that cannot be moved is a floating thing in the way.
 * Where he is put is remembered in that browser and nowhere else — it is a
 * convenience, not data, so localStorage is right and every read and write is
 * wrapped, because private windows and blocked site data make it throw.
 *
 * THE BUTTON STAYS STILL WHILE THE PANEL GROWS. That is why the element is
 * anchored by its BOTTOM edge in the lower half of the screen and by its TOP
 * edge in the upper half, flipping the stacking order with it. Anchor it by
 * the top everywhere and the dog jumps downward every time the panel opens.
 *
 * DELIVERY TIME IS ABSENT ON PURPOSE. It is the one question here that nobody
 * has given me a verified number for, and a wrong number in a help bubble is
 * worse than no bubble.
 */
(function () {
  'use strict';

  if (window.__crChuppi) return;
  window.__crChuppi = true;

  var CDN = 'https://coasterz.store/cdn/shop/files/' +
    'f2954a16-6765-4b30-9436-31c686d6ce59-removebg-preview.png?v=1713446570';
  var SHOP = 'https://cdn.shopify.com/s/files/1/0693/9590/6779/files/';
  var KEY = 'cr-chuppi-pos';

  /* THREE DRAWINGS OF THE SAME DOG. The open-eyed one is the site's favicon,
     which is where this whole thing started. The other two were drawn to match
     it and then measured against it rather than trusted: the blink frame's
     silhouette overlaps the original by 98.5%, which is what makes a swap read
     as one dog blinking instead of two pictures changing places
     (tools/chuppi_align_frames.py).

     A blink cannot be faked from one picture — that was tried, and a lid the
     colour of his fur came out as a brown blob on his face, because the fur
     around his eyes is a gradient with visible strokes. Hence real frames. */
  var FRAMES = {
    open: CDN + '&width=240',
    blink: SHOP + 'cr-chuppi-blink.png?v=1792354130&width=240',
    wave: SHOP + 'cr-chuppi-wave.png?v=1792354130&width=240'
  };

  var QUESTIONS = [
    {
      q: 'Where do you ship?',
      a: 'Worldwide. Rates are worked out at checkout from the delivery ' +
         'address, so you see the real figure before you pay.'
    },
    {
      q: 'Is shipping free?',
      a: 'Free worldwide shipping is for subscribers. Subscribe and it ' +
         'applies to your order — no minimum, and it does not expire.'
    },
    {
      q: 'What are the coasters made of?',
      a: 'Every design comes as a set of four, the same painting on all ' +
         'four. 3.75 inches square, a high‑gloss hardboard top and a ' +
         'natural cork back. They travel in one parcel.'
    },
    {
      q: 'And the mugs?',
      a: '11oz ceramic and dishwasher safe, with the story of the painting ' +
         'printed on the back of the mug.'
    }
  ];

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  var root = el('div', 'cr-chup');

  /* ---- the button ---- */
  var btn = el('button', 'cr-chup__btn');
  btn.type = 'button';
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-label', 'Ask Chuppi');
  btn.innerHTML = '<img src="' + FRAMES.open + '" alt="Chuppi, the shop\'s ' +
    'Shih Tzu" width="84" height="84" draggable="false">';
  var tag = el('span', 'cr-chup__tag', 'Ask Chuppi');
  btn.appendChild(tag);

  /* ---- the panel ---- */
  var panel = el('div', 'cr-chup__panel');
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Ask Chuppi');

  var qs = QUESTIONS.map(function (item) {
    return '<details class="cr-chup__q"><summary>' + esc(item.q) +
      '</summary><p>' + esc(item.a) + '</p></details>';
  }).join('');

  panel.innerHTML =
    '<button type="button" class="cr-chup__x" aria-label="Close">×</button>' +
    '<div class="cr-chup__head">' +
      '<img src="' + CDN + '&width=96" alt="" width="44" height="44">' +
      '<div><p class="cr-chup__name">Chuppi</p>' +
      '<span class="cr-chup__role">Here to help — and you can drag me</span>' +
      '</div>' +
    '</div>' +
    qs +
    '<form class="cr-chup__form" method="post" action="/contact#contact_form" ' +
      'accept-charset="UTF-8">' +
      '<input type="hidden" name="form_type" value="contact">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<p class="cr-chup__formtitle">Ask us anything else</p>' +
      '<label class="cr-chup__label" for="cr-chup-email">Your email</label>' +
      '<input class="cr-chup__input" id="cr-chup-email" type="email" ' +
        'name="contact[email]" autocomplete="email" required>' +
      '<label class="cr-chup__label" for="cr-chup-body">Your message</label>' +
      '<textarea class="cr-chup__area" id="cr-chup-body" name="contact[body]" ' +
        'rows="3" required></textarea>' +
      '<button class="cr-chup__go" type="submit">Send</button>' +
      '<p class="cr-chup__err" hidden></p>' +
    '</form>' +
    '<p class="cr-chup__done" hidden>Thank you — the message is with us, ' +
      'and a person will write back.</p>' +
    '<button type="button" class="cr-chup__reset" hidden>Put Chuppi back in ' +
      'the corner</button>';

  root.appendChild(panel);
  root.appendChild(btn);
  document.body.appendChild(root);

  var reset = panel.querySelector('.cr-chup__reset');

  /* ---- blinking, and the paw ---- */

  var face = btn.querySelector('img');
  var still = !!(window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var busy = false;    /* a wave is playing, so the blink waits its turn */
  var hovering = false;

  /* A WAVE NEEDS TWO POSES OF THE PAW, AND THERE IS ONE, SO IT IS OFF.
     Natalie, on seeing it: "הרמת היד קצת בולת מדי, שזו החלפת תמונה, זה לא
     נראה כמו הנפשה (לעומת זאת המצמוץ נראה מאוד אותנטי)". That is exactly
     right, and the reason is worth keeping because it governs every frame we
     ever add:

     A BLINK IS AN EVENT. The eye shuts and opens inside 130ms and the brain
     fills in what it did not see, so two frames are enough.

     A WAVE IS A MOTION, and a raised paw is only its halfway point. Holding
     one pose for most of a second and snapping back cannot read as waving,
     however it is faded or eased — there is nothing for the brain to fill in,
     because nothing moved. Two alternating paw poses would read as a wave the
     same way two eye poses read as a blink.

     To switch it on, put both paw frames in this array. The player below
     alternates them and needs no other change. */
  var WAVE = [];

  function show(which) { face.src = FRAMES[which] || FRAMES.open; }

  function blinkOnce(then) {
    show('blink');
    setTimeout(function () {
      show('open');
      if (then) then();
    }, 130);
  }

  function nextBlink() {
    /* Four to seven seconds, drawn fresh each time. A blink on a metronome
       reads as a blinking light; an uneven one reads as a living thing. And
       people blink twice in a row surprisingly often, so he does too. */
    setTimeout(function () {
      if (!busy && !hovering && !drag && !document.hidden) {
        blinkOnce(function () {
          if (Math.random() < 0.3) setTimeout(blinkOnce, 180);
        });
      }
      nextBlink();
    }, 4000 + Math.random() * 3000);
  }

  /* Alternates the paw poses three times over and puts him back. With fewer
     than two poses it does nothing at all, which is the current state. */
  function wave() {
    if (still || WAVE.length < 2) return;
    busy = true;
    var i = 0;
    (function step() {
      if (i >= WAVE.length * 3) {
        show('open');
        busy = false;
        return;
      }
      face.src = WAVE[i % WAVE.length];
      i += 1;
      setTimeout(step, 180);
    })();
  }

  /* HE RAISES HIS PAW WHILE THE POINTER IS ON HIM. Her idea, and the right
     home for the one paw pose we have: a hover is held for as long as someone
     stays, so a held drawing fits it exactly where a one-second "wave" did
     not. Pointer devices only — on a touch screen there is no hovering, and
     firing this on a tap would just flash the paw before the panel opens. */
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    btn.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch' || drag) return;
      hovering = true;
      show('wave');
    });

    btn.addEventListener('pointerleave', function () {
      hovering = false;
      if (!busy) show('open');
    });
  }

  if (!still) {
    /* the extra frames are fetched only after the page has settled, so a
       corner ornament never competes with the shop for the first load */
    setTimeout(function () {
      [FRAMES.blink, FRAMES.wave].concat(WAVE).forEach(function (src) {
        var pre = new Image();
        pre.src = src;
      });
      nextBlink();
    }, 2000);
  }

  /* ---- where he stands ---- */

  function place(left, top) {
    var bw = btn.offsetWidth || 84;
    var bh = btn.offsetHeight || 84;
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    left = clamp(left, 4, Math.max(4, vw - bw - 4));
    top = clamp(top, 4, Math.max(4, vh - bh - 4));

    /* THE PANEL OPENS INTO THE ROOM, NOT OFF THE EDGE. The element is pinned
       by whichever two edges he is nearest, so the panel — which is wider and
       taller than he is — can only ever grow inward. Pin it from the right
       everywhere and dragging him to the left half puts most of the panel off
       the side of the screen, which is exactly what happened the first time. */
    var isLeft = (left + bw / 2) < vw / 2;
    if (isLeft) {
      root.style.left = left + 'px';
      root.style.right = 'auto';
    } else {
      root.style.left = 'auto';
      root.style.right = (vw - (left + bw)) + 'px';
    }

    var isTop = (top + bh / 2) < vh / 2;
    if (isTop) {
      root.style.top = top + 'px';
      root.style.bottom = 'auto';
    } else {
      root.style.top = 'auto';
      root.style.bottom = (vh - (top + bh)) + 'px';
    }

    root.classList.toggle('cr-chup--top', isTop);
    root.classList.toggle('cr-chup--left', isLeft);

    /* and how much room is actually left for the panel in that direction, so
       a dog parked halfway down the screen cannot push half the form past the
       edge where nobody can scroll to it */
    root.style.setProperty(
      '--cr-chup-room',
      Math.max(160, (isTop ? vh - top - bh : top) - 24) + 'px');

    return { left: left, top: top };
  }

  function save(left, top) {
    var bw = btn.offsetWidth || 84;
    var bh = btn.offsetHeight || 84;
    var mx = Math.max(1, window.innerWidth - bw);
    var my = Math.max(1, window.innerHeight - bh);
    try {
      localStorage.setItem(KEY, JSON.stringify({ x: left / mx, y: top / my }));
    } catch (e) { /* private window, blocked site data — he just forgets */ }
    reset.hidden = false;
  }

  function restore() {
    var raw;
    try { raw = localStorage.getItem(KEY); } catch (e) { return; }
    if (!raw) return;
    var p;
    try { p = JSON.parse(raw); } catch (e) { return; }
    if (!p || typeof p.x !== 'number' || typeof p.y !== 'number') return;
    var bw = btn.offsetWidth || 84;
    var bh = btn.offsetHeight || 84;
    place(p.x * (window.innerWidth - bw), p.y * (window.innerHeight - bh));
    reset.hidden = false;
  }

  function forget() {
    try { localStorage.removeItem(KEY); } catch (e) { /* nothing to undo */ }
    root.style.left = root.style.right = '';
    root.style.top = root.style.bottom = '';
    root.style.removeProperty('--cr-chup-room');
    root.classList.remove('cr-chup--top', 'cr-chup--left');
    reset.hidden = true;
  }

  restore();
  window.addEventListener('resize', function () {
    if (reset.hidden) return;   /* still in his default corner, CSS has it */
    var r = btn.getBoundingClientRect();
    place(r.left, r.top);
  });

  /* ---- picking him up ---- */

  var drag = null;
  var pointerHandled = 0;

  btn.addEventListener('pointerdown', function (e) {
    if (e.button) return;                       /* left button / touch only */
    var r = btn.getBoundingClientRect();
    drag = { id: e.pointerId, sx: e.clientX, sy: e.clientY,
             ox: r.left, oy: r.top, moved: false };
    try { btn.setPointerCapture(e.pointerId); } catch (err) { /* ok */ }
  });

  btn.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.sx;
    var dy = e.clientY - drag.sy;
    /* a few pixels of slop, so a slightly shaky tap is still a tap */
    if (!drag.moved && Math.abs(dx) + Math.abs(dy) < 6) return;
    if (!drag.moved) {
      drag.moved = true;
      root.classList.add('is-dragging');
      setOpen(false);
    }
    drag.at = place(drag.ox + dx, drag.oy + dy);
  });

  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var moved = drag.moved;
    var at = drag.at;
    drag = null;
    pointerHandled = Date.now();
    root.classList.remove('is-dragging');
    if (moved) {
      if (at) save(at.left, at.top);
    } else {
      setOpen(!root.classList.contains('is-open'));
    }
  }

  btn.addEventListener('pointerup', endDrag);
  btn.addEventListener('pointercancel', endDrag);

  /* A KEYBOARD activation fires a click with no pointer sequence before it,
     and that is the only case this handler is for.

     Testing e.detail === 0 looked like the way to tell a keyboard press from
     a mouse one, and it is NOT: a synthetic or automated click also reports
     detail 0. The panel then opened on pointerup and closed again on the
     click, so a click appeared to do nothing at all. Asking whether a pointer
     sequence just handled this press is the test that holds for every kind of
     click. */
  btn.addEventListener('click', function () {
    if (Date.now() - pointerHandled < 500) return;
    setOpen(!root.classList.contains('is-open'));
  });

  reset.addEventListener('click', forget);

  /* ---- open and close ---- */

  function setOpen(open) {
    var was = root.classList.contains('is-open');
    root.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      if (!was) wave();          /* he says hello, once, on the way in */
      var first = panel.querySelector('summary');
      if (first) first.focus();
    }
  }

  panel.querySelector('.cr-chup__x').addEventListener('click', function () {
    setOpen(false);
    btn.focus();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      setOpen(false);
      btn.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (root.classList.contains('is-open') && !root.contains(e.target)) {
      setOpen(false);
    }
  });

  /* ---- the message ---- */

  var form = panel.querySelector('.cr-chup__form');
  var err = panel.querySelector('.cr-chup__err');
  var done = panel.querySelector('.cr-chup__done');
  var go = panel.querySelector('.cr-chup__go');

  form.addEventListener('submit', function (e) {
    if (!window.fetch || !window.FormData) return; /* ordinary submit */
    e.preventDefault();
    err.hidden = true;
    go.disabled = true;
    go.textContent = 'Sending…';

    fetch('/contact', { method: 'POST', body: new FormData(form) })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        form.hidden = true;
        done.hidden = false;
      })
      .catch(function () {
        /* the endpoint is Shopify's own, so a failure here is the network or
           a blocked fetch. Send it the plain way rather than lose the note —
           .submit() on the prototype does not fire the submit event, so this
           cannot loop back into the handler above. */
        HTMLFormElement.prototype.submit.call(form);
      });
  });
})();
